import _implicitStylesheets from "./buttonToggle.css";
import _implicitScopedStylesheets from "./buttonToggle.scoped.css?scoped=true";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<button type="button" class="toggle-button${0}"${"a0:data-value"}${"a0:aria-pressed"}${"a0:disabled"}${2}>${"t1"}</button>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, k: api_key, b: api_bind, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, i: api_iterator, h: api_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.toggleClass),
    attrs: {
      "role": "group",
      "aria-label": $cmp.ariaLabel
    },
    key: 0
  }, api_iterator($cmp.rows, function (row) {
    return api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
      props: {
        "type": "button",
        "context": row.analyticsContext
      },
      key: api_key(1, row.value)
    }, [api_static_fragment($fragment1, 3, [api_static_part(0, {
      on: {
        "click": _m1 || ($ctx._m1 = api_bind($cmp.handleClick))
      },
      attrs: {
        "data-value": row.value,
        "aria-pressed": row.pressed,
        "disabled": row.disabled ? "" : null
      }
    }, null), api_static_part(1, null, api_dynamic_text(row.label))])]);
  }))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4b7fgnr04mc";
tmpl.legacyStylesheetToken = "undefined-_buttonToggle";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
